<script setup lang="ts">
import { computed, ref } from 'vue';
import Dialog from 'primevue/dialog';
import LoadingMask from './LoadingMask.vue';

interface ExternalPagePopupProps {
  url: string;
  visible: boolean;
}

const props = defineProps<ExternalPagePopupProps>();
const emit = defineEmits<{ (e: 'update:visible', value: boolean): void }>();

const isLoading = ref(true);

const isVisible = computed({
  get() {
    return props.visible;
  },
  set(visible: boolean) {
    emit('update:visible', visible);
  },
});
</script>
<template>
  <Dialog
    v-model:visible="isVisible"
    modal
    :pt="{
      root: {
        style: {
          maxHeight: '100%',
          borderRadius: '0.5rem'
        }
      }
    }"
  >
    <template #container="{ closeCallback}">
      <div class="w-full h-full p-4 flex flex-col gap-4 lg:w-[98vw] lg:h-[96vh]">
        <div class="grow-0 flex p-2 justify-end">
          <span class="pi pi-times cursor-pointer" aria-label="Close popup" @click="closeCallback" />
        </div>
        <div class="grow w-full">
          <LoadingMask :loading="isLoading" />
          <iframe
            v-show="!isLoading"
            :src="props.url"
            class="w-full h-full border-none overflow-auto"
            @load="isLoading = false"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>
